import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const msg = error.response.data?.message || "";
      if (typeof msg === "string" && (msg.includes("Multiple login") || msg.includes("terminated") || msg.includes("Session identifier"))) {
        localStorage.clear();
        alert("Multiple login detected. This session has been terminated.");
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
